import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Stack, Box, Button, Divider} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import LoadingSpinner from '@salesforce/retail-react-app/app/components/loading-spinner'
import {cardStyles} from './index.styles'

const ActionCard = ({
    children,
    onEdit,
    onRemove,
    editBtnRef,
    editBtnLabel,
    removeBtnLabel,
    enableShippingAddressDelete = true,
    showDivider = false,
    ...props
}) => {
    const [showLoading, setShowLoading] = useState(false)

    const handleRemove = async () => {
        setShowLoading(true)
        try {
            return await Promise.resolve(onRemove())
        } finally {
            setShowLoading(false)
        }
    }

    return (
        <Box
            spacing={4}
            p={4}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            height="100%"
            {...props}
        >
            {showLoading && <LoadingSpinner />}

            <Box flexGrow={1} display="flex" alignItems="end" w="full">
                {children}
            </Box>
            <Stack direction="row" spacing={showDivider ? 2 : 4} sx={cardStyles}>
                {onEdit && (
                    <Button
                        onClick={onEdit}
                        variant="link"
                        ref={editBtnRef}
                        aria-label={editBtnLabel}
                        className="edit primary-link"
                    >
                        <FormattedMessage defaultMessage="Edit" id="action_card.action.edit" />
                    </Button>
                )}
                {showDivider && (
                    <Box w="2px" h="100%" background="cav_light_input_gray" borderRadius="1px" />
                )}
                {onRemove && enableShippingAddressDelete && (
                    <Button
                        variant="link"
                        onClick={handleRemove}
                        aria-label={removeBtnLabel}
                        className="remove primary-link"
                    >
                        <FormattedMessage defaultMessage="Delete" id="action_card.action.delete" />
                    </Button>
                )}
            </Stack>
        </Box>
    )
}

ActionCard.propTypes = {
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    children: PropTypes.node,
    editBtnRef: PropTypes.object,
    editBtnLabel: PropTypes.string,
    removeBtnLabel: PropTypes.string,
    enableShippingAddressDelete: PropTypes.bool,
    showDivider: PropTypes.bool
}

export default ActionCard
